import bgImage from '../assets/Background.png';

 // === STYLE OPTIONS ===
  const headingFont = "Montserrat, Arial, sans-serif";
  const headingSize = "2.8rem";
  const headingColor = "#db8787ff";

  const paraFont = "Montserrat, Arial, sans-serif";
  const paraSize = "1.22rem";
  const paraColor = "#fbfbfbff";

  // Choose: "flex-start", "center", or "flex-end"
  const verticalAlign = "flex-start";
  // Choose: "flex-start", "center", or "flex-end"
  const horizontalAlign = "center";
  // Set textAlign for text (left/center/right)
  const textAlign = "center";

const paraStyle = {
  fontFamily: paraFont,
  fontSize: paraSize,
  color: paraColor,
  margin: "0 0 18px 0",
  lineHeight: 1.7
};


const headingstyle= {

      fontFamily: headingFont,
      fontSize: "2rem",
      color: headingColor,
      margin: "32px 0 12px 0"
};


export default function Terms() {
  return (
   <div
    style={{
      padding: "36px 12px",
      minHeight: "100vh",
      overflowY: "auto",
      // marginLeft: 220 for side menu if needed
    }}
  >


      <h1
  style={{
    fontFamily: headingFont,
    fontSize: headingSize,
    color: headingColor,
    margin: 0,
    textAlign: textAlign
  }}
>
  Terms & Conditions
</h1>
     
  <div
  style={{
    marginTop: 18,
    width: "100%", // Fill full width of parent
    maxWidth: 1800, // Limit to readable width
    marginLeft: "auto", // Center horizontally
    marginRight: "auto",
    padding: "0 24px", // Add left/right padding
    textAlign: "left"
  }}
>

  <p
    style={paraStyle}
  >
  These are the terms and conditions (the ‘Terms’) on which you may make use of the website www.uaspakistan.com (a ‘Website’), 
  whether as a guest or a registered user. Please read these Terms carefully before you start to use the Website. By using the Website, 
  regardless of how you access it, you confirm that you accept these Terms and that you agree to abide by them.
  </p>

 <p
    style={paraStyle}
  >
    If you do not agree to these Terms, please refrain from using the Website.
  </p>

  {/* Section Title */}
  <h2
    style={headingstyle}
  >
    1.	About UAS (Universities Admission Service)
  </h2>

  {/* Paragraph under section */}
  <p
    style={paraStyle}
  >
    1.1 We are the Universities Admission Service, incorporated Service in Pakistan whose office is at Contact Us page. (‘UAS’, ‘we’, ‘us’).
  </p>

  <p
    style={paraStyle}
  >
1.2 You can contact us by telephone if provided by the us, using our contact us page, or in writing to the above.
  </p>
 <p
    style={paraStyle}
  >
1.3 Our role is to provide admission services across a range of subject areas and study modes for education providers and
 Students, which is governed by our mission statement in that relevant section of our website.
  </p>


 {/* Section Title */}
  <h2
    style={headingstyle}
  >
    2. Changes to the Terms
  </h2>

<p
    style={paraStyle}
  >
2.1 We reserve the right at all times to vary, change, alter, amend, add to or remove any of these Terms. Please ensure 
that you review these Terms each time you use the Website as you will be deemed to have accepted a variation if you continue
 to use the Website after the variation has been posted. 
 </p>


<p
    style={paraStyle}
  >
2.2 The current draft of these Terms was adopted and published on 20 April 2025. </p>

<p
    style={headingstyle}
  >
3. Information about you and visits to the Website </p>

<p
    style={paraStyle}
  >
3.1 We process information about you in accordance with the sole purpose of providing facilitation to students and Universities
in admissions Process. By using the Website, you consent to such processing and you warrant that all data provided by you is accurate. </p>
<p
    style={paraStyle}
  >
3.2 You will be asked to register, using certain personal details, before being given access to certain areas of our Website, 
including in order to make an application to an education provider using our Apply service. We may use the details you provide 
in future to contact you in accordance with our purpose of operations. You agree to disclose true and complete information during
 the account registration process, and to update your information if and when it changes. Your use of our ‘Apply’ service is
  governed by the Declaration. </p>


 <p
    style={headingstyle}
  >
4. Access to and use of our Website </p>
<p
    style={paraStyle}
  >
4.1 You may only use the Website for lawful purposes. When using the Website, you must not: </p>


<p
    style={paraStyle}
  >
4.1.1 decrypt, extract, disassemble, reverse-engineer or decompile the Website </p>

<p
    style={paraStyle}
  >
4.1.2 use the Website in any way that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect </p>

<p
    style={paraStyle}
  >
4.1.3 include any portion of the Website in any other software program </p>

<p
    style={paraStyle}
  >
4.1.4 develop methods to enable unauthorised parties to use the Website </p>

<p
    style={paraStyle}
  >
4.1.5 create any modifications or derivative works directly or indirectly using the Website, or components thereof </p>

<p
    style={paraStyle}
  >
4.1.5 create any modifications or derivative works directly or indirectly using the Website, or components thereof </p>
<p
    style={paraStyle}
  >
4.1.6 knowingly transmit any data, send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke 
loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any 
computer software or hardware of the Website </p>
<p
    style={paraStyle}
  >
4.1.7 damage, interfere with or disrupt the Website in any way </p>
<p
    style={paraStyle}
  >
4.1.8 use the Website or information obtained from the Website to transmit, or procure the sending of, any unsolicited or unauthorised 
advertising or promotional material or any other form of similar solicitation (spam)</p>
<p
    style={paraStyle}
  >
4.1.9 use the Website for any purpose that is unlawful, improper or illegal, or in breach of any, or for the purpose of breaching any, law </p>
<p
    style={paraStyle}
  >
4.1.10 use the Website in a way which infringes the rights of or harasses anyone else, is harmful to, or otherwise restricts or inhibits
 anyone else's use and enjoyment of the Website </p>
<p
    style={paraStyle}
  >
4.1.11 use the Website to impersonate any person or entity or falsely state or misrepresent your affiliation with a person or entity </p>
<p
    style={paraStyle}
  >
4.1.12 post comments about yourself which are not in good faith and in accordance with your honestly held beliefs </p>
<p
    style={paraStyle}
  >
4.1.13 use the Website for the purpose of harming or attempting to harm minors in any way </p>
<p
    style={paraStyle}
  >
4.1.14 use contact details obtained using the Website to harass any person </p>
<p
    style={paraStyle}
  >
4.2 Access to the Website is permitted on a temporary basis, and we reserve the right to withdraw or amend the service we provide on our Website 
without notice. We will not be liable if for any reason the Website is unavailable at any time or for any period.  </p>
<p
    style={paraStyle}
  >
4.3 We will use our reasonable endeavours to make the Website available but cannot guarantee that the Website will operate continuously or 
without interruption or be error-free. You must not attempt to interfere with the proper working of the Website and, in particular, you must
 not attempt to circumvent security, tamper with, hack into, or otherwise disrupt any computer system, server, website, router or any other
  internet connected device. You are also advised to use the appropriate antivirus software before and during access to the Website. </p>

<p style={paraStyle}>
4.4 We reserve the right, at any time and for any reason or none, to suspend or terminate your access to, or use of, the Website, or any part thereof.
 We may also restrict access to some parts of our Website to users who have registered with us. </p>
<p
    style={paraStyle}
  >
4.5 Where you choose or are provided with a Personal ID, code, password or any other piece of information as part of our security procedures, 
you must treat such information as confidential, and you must not disclose it to any third party. Please ensure that you log off when not using 
the Website and ensure that devices which you use to access the Website are securely locked when not in your possession. You must notify us if you 
suspect there has been any unauthorised use of your Personal ID, code or password or any other breach of security. </p>

<p
    style={paraStyle}
  >
4.6 We have the right to disable any Personal ID, code or password, whether chosen by you or allocated by us, at any time, if in our opinion you have
 failed to comply with any of the provisions of these Terms. We will not be liable for any loss or damage whatsoever resulting from the disclosure of 
 your Personal ID, code or password contrary to these Terms. 4.6 We have the right to disable any Personal ID, code or password, whether chosen by you 
 or allocated by us, at any time, if in our opinion you have failed to comply with any of the provisions of these Terms. We will not be liable for any 
 loss or damage whatsoever resulting from the disclosure of your Personal ID, code or password contrary to these Terms.  </p>
<p
    style={headingstyle}
  >
5. Intellectual property rights  </p><p
    style={paraStyle}
  >
5.1 We are the owner or licensee of all copyright and other intellectual property rights in any material contained on the Website. </p>
<p
    style={paraStyle}
  >
5.2 You may access any part of the Website and download or copy material (by printing off individual pages onto paper) or download material on to 
disk (but not on to any server or other device connected to a network) for personal non-commercial use only. The intellectual property rights in such 
material shall be retained by us or, where the material has been licensed to UAS, by the owners of the rights in the material. Copying, distributing 
or any use of the material contained on the Website for any commercial purpose is prohibited. </p><p
    style={paraStyle}
  >
5.3 The Website contains trademarks which belong to UAS or which have been licensed to UAS by the trademark owners. Any use of these trademarks by 
you is forbidden unless prior written permission has been obtained from the trademark owner. UAS will take legal action against any individual or 
organisation which seeks to use UAS' name, material, logos or trademarks for unlawful purposes.</p><p
    style={paraStyle}
  >
5.4 You may not remove any copyright, trademark or intellectual property notices contained in the original material from any material downloaded 
or copied from the Website. </p><p
    style={paraStyle}
  >
5.5 Links to the Website are not permitted, other than links to the homepage for your personal use, except with our prior written permission.
 Links to the website from within a frameset definition are not permitted except with our prior written permission. </p><p
    style={paraStyle}
  >
5.6 You may not create a database by systematically downloading substantial parts of the Website. </p><p
    style={paraStyle}
  >
5.7 The data we make available through our website, in any section, that is provided in an open data format (typically CSV), is licensed 
subject to the terms of the use, which is non-commercial use strictly. </p><p
    style={paraStyle}
  >
5.8 Any rights not expressly granted in these Terms, or any document referenced in them, are reserved to UAS. </p><p
    style={headingstyle}
  >

6. Uploading content to the Website
 </p><p
    style={paraStyle}
  >
6.1 When you are invited to upload video content you have created (‘Content’) you can do this by submitting it to us. UAS is not liable for 
technical, hardware, or software failures of any kind or lost, inconsistent or unavailable network connections that may limit or prohibit Content 
being uploaded. We may use any Content you upload, but we cannot promise to. You warrant that you are legally entitled to post the Content and to 
grant to us the licence referred to in clause 6.3 below. </p><p
    style={paraStyle}
  >
6.2 By uploading video content you confirm that it is your own work. You undertake that, prior to uploading any Content to our Website, you have 
permission, including any assignments, waivers, licences, rights, consents, and permissions (‘Permissions’) in respect of anyone else's rights in or 
to the Content (including, without limitation, all intellectual property rights, moral rights, performance rights (which include any music used in your video)
 rights to privacy, image rights and publicity rights), which give you (and us, relying on your agreement to these Terms) the right to immediately use, publish,
  reproduce, distribute, produce derivative works of, edit, perform, display and broadcast the uploaded Content in any media formats and through any media channels
   without liability to any third party. UAS reserves the right to require proof that all necessary Permissions have been given and you agree, on request, to provide 
   written evidence of those Permissions (including parental consent if necessary) and perform such acts as UAS may reasonably require. </p><p
    style={paraStyle}
  >
6.3 When you upload or post Content to our website, you:  </p><p
    style={paraStyle}
  >
6.3.1 grant to us an irrevocable, perpetual, worldwide, non-exclusive, royalty-free, transferable licence (with right to sub-license) to use, publish, 
reproduce, distribute, produce derivative works of, display, broadcast and perform the Content in part or as a whole, in any media formats and through any media channels </p>
<p
    style={paraStyle}
  >
6.3.2 waive all moral rights in the Content</p>
<p
    style={paraStyle}
  >
6.4 You agree that you will not upload any Content which is illegal, defamatory, obscene, incites prejudice or hatred or which it is unlawful for you
 to possess in the country in which you are resident or in Pakistan, or which it would be unlawful for us to use or to hold. </p>
<p
    style={paraStyle}
  >
6.5 If you are under 18 years of age, then by uploading Content you confirm that you have the permission of your parent or guardian to do so. </p>
<p
    style={paraStyle}
  >
6.6 You warrant that any Content uploaded by you shall fully comply with these Terms, and you will be liable to us and indemnify us for any breach of 
that warranty. If you are in any doubt about your Content or whether or not (being under 18 years) you have your parent's or guardian's permission, 
then you should not upload it. </p>
<p
    style={paraStyle}
  >
6.7 We shall be entitled to disclose your identity to any third party who claims that any Content uploaded by you infringes their rights. </p>
<p
    style={headingstyle}
  >

7. Links to other websites
 </p>
<p
    style={paraStyle}
  >
7.1 UAS provides links to website and other resources provided by third parties, and aims to link to websites that we feel will enhance your experience by offering 
useful background knowledge, specialist advice and information, and informed commentary and views. We only provide links to websites which we hope enhance your experience 
of using the Website; please tell us if they don’t. When linking to third party websites, we use an icons and symbols to make it clear for you sometimes on our website. </p>
<p
    style={paraStyle}
  >
7.2 The existence of links from the Website to external websites does not mean that we endorse or promote those websites, the views of their developers, products or 
services made available on them. We have no control over the content of those external websites or other third-party resources, and accept no responsibility for and 
exclude all liability that may arise with respect to them or for any loss or damage that may arise from your use of them. </p>
<p
    style={paraStyle}
  >
7.3 We might receive payment or payments in kind in respect of websites or other resources to which links are provided. If content is sponsored, or part of UAS Student
 Discounts, or if it is included within the context of any advert or premotion, we make this clear. We may will also link to content which is free to access, but you may 
 sometimes be asked to register or subscribe to an offer or service once you leave the Website, by the operator of a linked website. We will not link to websites which require 
 you to pay before you view the content on them. However, we do not accept any responsibility for any payment made on third party website and take this opportunity to warn you 
 to take all the due diligence before you pay anyone in any capacity and/or for any purpose. </p>
<p
    style={paraStyle}
  >
7.4 We fix or remove missing, broken, or redirected links whenever we find them. If you spot anything which isn’t working in the way you would expect it to, please let us know. </p>
<p
    style={headingstyle}
  >

8. Disclaimer and limitation of liability
 </p>
<p
    style={paraStyle}
  >
8.1 UAS has taken care to ensure that the information on the Website is correct. However, no warranty, express or implied, is given as to: (i) its accuracy; 
or (ii) its availability, and UAS does not accept any liability for error or omission. UAS is not responsible for how the information is used, how it is interpreted 
or what reliance is placed on it. We do not guarantee that the information on the Website is fit for any particular purpose. You should also be aware that the availability
 of courses of study is subject to conditions applied by individual institutions/Universities at their sole discretion. </p>
<p
    style={paraStyle}
  >
8.2 The content of the Website is for general information only and does not constitute any form of advice or recommendation upon which a specific decision should be made.
 UAS has taken steps to ensure the materials contained on its Website are current and accurate, but to the fullest extent permitted by law UAS hereby excludes any warranty,
  whether express or implied, by statute at common law,  Prevention of Electronic Crimes Act (PECA), 2016 or otherwise, relating to the Website and the material contained on 
  the Website. In particular (but without limitation of the above), UAS gives no warranties as to quality, accuracy, timeliness, completeness or fitness for a particular purpose 
  of the Website or of the material contained in it. </p>
<p
    style={paraStyle}
  >
8.3 To the fullest extent permitted by law, UAS shall not be liable for any claims, costs, penalties, loss (whether direct, indirect or consequential and whether economic or 
special loss of any nature), damages or expenses arising from the use or from the inability to use the Website. UAS does not accept liability from reliance on information or advice 
contained on the Website or from any unauthorised access or alteration to the Website by a third party. </p>
<p
    style={paraStyle}
  >
8.4 Whilst the Website may from time to time contain advertising material, UAS does not endorse or accept any liability for any of the products or services so advertised, or for
 any error or inaccuracy in the advertisements. Advertisers and sponsors are responsible for ensuring that material submitted for inclusion on the Website complies with all relevant laws. </p>
<p
    style={paraStyle}
  >
8.5 We shall have no liability to you for any breach of these Terms caused by any event or circumstance beyond our reasonable control, including, without limitation, 
strikes, lock-outs, or other industrial disputes, breakdown of systems or network access, or flood, fire, explosion or accident (Any type). </p>
  </div>
    </div>
  );
}
